export const MENU_TYPE_REQUEST = 'MENU_TYPE_REQUEST';
export const MENU_TYPE_SUCCESS = 'MENU_TYPE_SUCCESS';
export const MENU_TYPE_FAIL = 'MENU_TYPE_FAIL';

